module.exports = __webpack_public_path__ + "img/box06_02.0b45b7bc.jpg";